export const minChargebackTableColumnsWidth = {
  chargebackId: 150,
  chargebackCurrency: 78,
  reasonCode: 78,
  paymentMethodType: 87,
};
